import React from "react";
import { Flex, Image } from "@chakra-ui/react";
import asoemLogo from "../../img/asoemlogo.png";
import "./animations.css";

export default function Intro() {
	return (
		<Flex
			direction="column"
			alignItems="center"
			justifyContent="flex-start"
			bg="#777"
			w="100%"
			pt="20vh"
			px={4}
			className="intro-container"
			h="100vh"
			overflow={"hidden"}
		>
			<Image className="logo-animation" src={asoemLogo} filter="auto" />
			<div className="typewriter">
				<h1>Hechos, no palabras</h1>
			</div>

			{/* PERSONA CORRIENDO */}
			{/* <Flex position={"relative"} w={["100%", "500px"]} mt={3}>
				<div class="running">
					<div class="outer">
						<div class="body">
							<div class="arm behind"></div>
							<div class="arm front"></div>
							<div class="leg behind"></div>
							<div class="leg front"></div>
						</div>
					</div>
				</div>
			</Flex> */}
		</Flex>
	);
}
